export default "/images/c6083de6f8a3f5ac12b1338db1d5d4b3.avif";